
import { ReactNode } from "react";

import Header from "../organisms/Header"
import Footer from "../organisms/Footer";

type LayoutProps = {
  children: ReactNode;
};

export default function MainLayout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer/>
    </div>
  );
}
